export const arrayRemoveConsecutiveDuplicates = (array) => {
    return array.filter((item, index) => index === 0 || item !== array[index - 1]);
};
